import { render, staticRenderFns } from "./ranliaogl.vue?vue&type=template&id=96a8f326&scoped=true&"
import script from "./ranliaogl.vue?vue&type=script&lang=js&"
export * from "./ranliaogl.vue?vue&type=script&lang=js&"
import style0 from "./ranliaogl.vue?vue&type=style&index=0&id=96a8f326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a8f326",
  null
  
)

export default component.exports